import DescriptiveText from "./DescriptiveText";

export * from ".";
export default DescriptiveText;